import { render, staticRenderFns } from "./TableMeta.vue?vue&type=template&id=5137f8b5&"
import script from "./TableMeta.vue?vue&type=script&lang=js&"
export * from "./TableMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports